import Lenis from '@studio-freight/lenis';

class ScrollBuilder {
    constructor() {

        const lenis = new Lenis({
            duration: 1.5
        });

        lenis.on('scroll', (e) => {


            if (e.animatedScroll >= 96) {

                document.querySelector('.header').classList.add('sticky')

                if (e.direction == 1) {
                    document.querySelector('.header').classList.add('hide');
                }

                if (e.direction == -1) {
                    document.querySelector('.header').classList.remove('hide');
                }

            } else {
                document.querySelector('.header').classList.remove('sticky')
            }




        })

        function raf(time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }

        requestAnimationFrame(raf)

        return lenis;
    }
}

export const Scroll = new ScrollBuilder();
